var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('span',[(_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey) == true)?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("mdi-check-circle")]):_c('v-icon',{attrs:{"color":"error lighten-2"}},[_vm._v("mdi-close-circle")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }